import React from 'react';
import { TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { pxToRem } from '@withjoy/joykit/theme';

interface PercentageOffBadgeProps
  extends Readonly<{
    percentage: number;
  }> {}

export const PercentageOffBadge: React.FC<PercentageOffBadgeProps> = ({ percentage }) => {
  const { tq } = useTranslation('hotelTile');

  if (!percentage || percentage === 0) return null;

  return (
    <TextV2
      paddingX={{ _: 2, sm2: 3 }}
      typographyVariant="label3"
      paddingY={pxToRem(4)}
      fontSize={{ _: pxToRem(11), sm2: pxToRem(13) }}
      borderRadius="full"
      backgroundColor="accentGreen2"
      color="accentGreen3"
      width="fit-content"
      whiteSpace="nowrap"
    >
      {tq`Save ${percentage}%`}
    </TextV2>
  );
};
